export const FORM_FIELDS_REQUEST = "FORM_FIELDS_REQUEST";
export const FORM_FIELDS_SUCCESS = "FORM_FIELDS_SUCCESS";
export const FORM_FIELDS_FAILURE = "FORM_FIELDS_FAILURE";
export const FORM_FIELD_VALUE_CHANGED = "FORM_FIELD_VALUE_CHANGED";
export const FORM_FIELD_VALUE_RESET = "FORM_FIELD_VALUE_RESET";

